import { useState } from 'react'
import { useAppDispatch, useAppSelector } from '../../app/hooks'
import styles from './ShippingModal.module.scss'
import './ShippingModal.scss'
import { Grid, Typography } from '@material-ui/core'
import { ShippingModalTile } from './ShippingModalTile'
import ShippingAddressCard from './ShippingAddressCard'
import {
    postAddShipTo,
    selectOrderedShipTos,
    validShipToPayload,
} from '../../features/customer/customerSlice'
import { FilterIcon } from '../../GlobalComponents/_icons/Icons'
import {
    FastQuoteInput,
    StyledRadio,
    CountryDropdownList,
    StateDropdownList,
    AWCButton,
} from '../../GlobalComponents/Inputs/Inputs'
import {
    payloadToShipToRow,
    updateShipTo,
    updateTaxAuthorityCode,
} from '../../features/order/orderSlice'
import { Scrollbars } from 'react-custom-scrollbars-2'
import clsx from 'clsx'
import PlacesAutocomplete from 'react-places-autocomplete'
import Autocomplete from '@material-ui/lab/Autocomplete'
import LocationOnIcon from '@material-ui/icons/LocationOn'
import { AddShipToPayload } from '../../features/customer/customerAPI'
import { validUSZip } from './CreatePreSaleAccount'
import { logEvent } from '../../GlobalComponents/GlobalFunctions'

interface ShippingModalProps {
    close(): void
}

const PLACE_TYPES = {
    STATE: ['administrative_area_level_1'],
    COUNTRY: ['country'],
    CITY: ['locality', 'postal_town'],
    ZIPCODE: ['postal_code'],
}
// interface Address {
//     street1: string
//     street2: string
//     city: string
//     zipcode: string
//     state: string
//     country: string
// }

export const AutocompleteAddressInput = (props: any) => {
    const {
        placeholder = 'Street Address',
        span = '1',
        title = '',
        setZipcode,
        setCountry,
        setCity,
        setState,
        address,
        setAddress,
        validationText,
        disabled = false,
    } = props
    const callback = (place: any, status: any) => {
        if (status === google.maps.places.PlacesServiceStatus.OK) {
            populateFields(place)
        }
    }
    const clearFields = () => {
        setZipcode('')
        setCountry('')
        setCity('')
        setState('')
    }

    const populateFields = (placeDetails: any) => {
        clearFields()
        let components = placeDetails.address_components
        components.forEach((comp: any) => {
            let types = comp.types
            types.forEach((type: any) => {
                if (PLACE_TYPES.STATE.includes(type)) setState(comp.short_name)
                if (PLACE_TYPES.CITY.includes(type)) setCity(comp.short_name)
                if (PLACE_TYPES.COUNTRY.includes(type)) setCountry(comp.short_name)
                if (PLACE_TYPES.ZIPCODE.includes(type)) setZipcode(comp.short_name)
            })
        })
    }
    const getPlaceDetails = async (placeId: string) => {
        let request = {
            placeId: placeId,
            fields: ['address_components', 'formatted_address'],
        }
        const map = new google.maps.Map(document.createElement('div'))
        const service = new google.maps.places.PlacesService(map)
        service.getDetails(request, callback)
    }
    const handleSelect = (address: any, place?: any, suggestion?: any) => {
        getPlaceDetails(place)
        setAddress(suggestion.formattedSuggestion.mainText)
    }
    let addValue = (o: any, value: string) => {
        if (o.inputProps) o.inputProps.value = value
        return o
    }
    return (
        <PlacesAutocomplete value={address} onChange={setAddress} onSelect={handleSelect}>
            {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                <div style={{ gridColumn: `span ${span}` }}>
                    <Autocomplete
                        options={suggestions as any}
                        id="combo-box-demo"
                        disableListWrap
                        ListboxProps={{ style: { flexDirection: 'column' } }}
                        getOptionLabel={(option: any) => option.description}
                        freeSolo
                        disabled={disabled}
                        onInputChange={(e: any) => {
                            // x click returns e.target.value === 'undefined'
                            e && e.target.value === undefined && setAddress('')
                        }}
                        onClose={() => {
                            let a: any = suggestions.find((row) => row.active)
                            if (a) {
                                let { onClick } = getSuggestionItemProps(a, {})
                                onClick(a)
                            }
                        }}
                        // value={address}
                        renderInput={(params: any) => (
                            <FastQuoteInput
                                variant="outlined"
                                {...getInputProps({
                                    placeholder: placeholder,
                                    title: title,
                                    //stops chrome autocomplete dropdown
                                    autocomplete: 'new-password',
                                    //needs this too to stop it
                                    type: 'text',
                                })}
                                disabled={disabled}
                                maxLength={35}
                                {...addValue(params, address)}
                                useNativeOnChange
                                validationText={validationText}
                                testid={props.testid}
                            />
                        )}
                        onChange={(event, newValue: any) => {
                            if (newValue) {
                                let { onClick } = getSuggestionItemProps(newValue, {})
                                onClick(newValue)
                            } else {
                                clearFields()
                            }
                        }}
                        renderOption={(option) => {
                            if (!option) return
                            return (
                                <Grid container alignItems="center" direction="row">
                                    <Grid item>
                                        <LocationOnIcon style={{ marginRight: 10 }} />
                                    </Grid>
                                    <Grid item xs>
                                        <span>{option.formattedSuggestion.mainText}</span>
                                        <Typography variant="body2" color="textSecondary">
                                            {option.formattedSuggestion.secondaryText}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            )
                        }}
                    />
                </div>
            )}
        </PlacesAutocomplete>
    )
}
const sameShipTo = (shipTo1: any, shipTo2: any) => {
    return (
        shipTo1.ShipToAddress1 === shipTo2?.ShipToAddress1 &&
        shipTo1.ShipToAddress2 === shipTo2?.ShipToAddress2 &&
        shipTo1.ShipToZipcode === shipTo2?.ShipToZipcode &&
        shipTo1.ShipToState?.trim() === shipTo2?.ShipToState?.trim() &&
        shipTo1.ShipToCity === shipTo2?.ShipToCity &&
        shipTo1.ShipToName === shipTo2?.ShipToName
    )
}
const ShippingModal = (props: ShippingModalProps) => {
    const { close } = props
    const customer = useAppSelector((state) => state.customer.currentCustomer!)
    const currentShipTo = useAppSelector((state) => state.order.currentShipTo!)
    const [filter, setFilter] = useState('')
    const [fields, setFields] = useState<AddShipToPayload>({
        accountCode: customer.AccountCode,
        country: 'US',
        state: '',
        city: '',
        address1: '',
        address2: '',
        zipcode: '',
        name: '',
        isDefault: false,
    })
    const dispatch = useAppDispatch()
    const shipTos = useAppSelector((state) =>
        selectOrderedShipTos(state, state.customer.currentCustomer!.AccountCode)
    )
    const filteredShipTos =
        shipTos &&
        shipTos.filter((account) =>
            JSON.stringify(account).toLowerCase().includes(filter.toLowerCase())
        )
    const [newAddress, setNewAddress] = useState(false)
    const [hasAddress2, setHasAddress2] = useState(false)
    const [failedToAdd, setFailedToAdd] = useState(false)

    function handleZipBlur(e: any) {
        setZipFieldActive(false)
    }
    const [zipFieldActive, setZipFieldActive] = useState<boolean>(false)

    const onCancelClick = () => {
        setNewAddress(false)
        setFields({
            accountCode: customer.AccountCode,
            country: 'US',
            state: '',
            city: '',
            address1: '',
            address2: '',
            zipcode: '',
            name: '',
            isDefault: false,
        })
    }
    const [resetPage, setResetPage] = useState(false)
    return (
        <div className={styles.shippingModal} data-testid="shippingModal">
            <div className={styles.shippingModalHeader}>
                <div className={styles.shippingModalTitle}>{`${
                    customer.ShipToName
                } (${customer.AccountCode.trim()})`}</div>
                <div onClick={close} data-testid="shippingModalClose" className={'a-i-close'} />
            </div>
            <div className={'a-divider'} />

            <Scrollbars
                // style={{ height: '100'}}
                renderTrackHorizontal={() => <div />}
                autoHeight
                autoHeightMin={200}
                autoHeightMax={'70vh'}
            >
                <div className={styles.modalBody}>
                    {!newAddress && shipTos && shipTos.length > 3 && (
                        <div style={{ marginTop: 2 }}>
                            <FastQuoteInput
                                Icon={FilterIcon}
                                onChange={setFilter}
                                placeholder={'Filter Addresses'}
                                disabled={newAddress}
                                value={filter}
                                renderEndIcon={() =>
                                    filter && (
                                        <div
                                            style={{ width: 18, height: 15 }}
                                            className={'a-i-close'}
                                            data-testid="filterAddressesCancel"
                                            // intentionally mousedown because mousedown triggers parent blur
                                            onMouseDown={() => {
                                                setFilter('')
                                                setResetPage(true)
                                            }}
                                            onMouseUp={() => {
                                                setResetPage(false)
                                            }}
                                        />
                                    )
                                }
                                testid="shippingModalFilterAddresses"
                            />
                        </div>
                    )}
                    <div>
                        {filteredShipTos.length > 0 ? (
                            <ShippingModalTile
                                width={280}
                                className={styles.addressSearchContainer}
                                topLevelClassname={styles.topContainer}
                                topLevelClassnameLeft={styles.topContainerLeft}
                                topLevelClassnameRight={styles.topContainerRight}
                                resetKey={resetPage}
                            >
                                {filteredShipTos &&
                                    filteredShipTos.map((row, i) => (
                                        <div
                                            className={styles.cardContainer}
                                            data-testid="shippingModalCardContainer"
                                        >
                                            <ShippingAddressCard
                                                shipTo={row}
                                                disabled={newAddress}
                                                selected={
                                                    // presale shipto may have placeholder shiptoID
                                                    row.ShipToID === currentShipTo.ShipToID ||
                                                    sameShipTo(row, currentShipTo)
                                                }
                                                last={i === shipTos.length - 1}
                                                // on orderScreen -- set order header shipTo
                                                onSelect={() => {
                                                    dispatch(updateShipTo({ shipTo: row }))
                                                    dispatch(
                                                        updateTaxAuthorityCode(
                                                            row.TaxAuthorityCode!
                                                        )
                                                    )
                                                    close()
                                                }}
                                            />
                                        </div>
                                    ))}
                            </ShippingModalTile>
                        ) : (
                            <div
                                className={clsx(['centered', styles.addressSearchPlaceholder])}
                                style={{ width: '100%' }}
                            >
                                {shipTos.length > 0 ? 'No Results for this filter' : 'No Results'}
                            </div>
                        )}
                    </div>

                    <div className={'a-divider'} style={{ marginTop: 10 }} />

                    {!newAddress && (
                        // <div
                        //     className={styles.createNewButton}
                        //     onClick={() => setNewAddress(true)}
                        // />
                        <span
                            className={styles.newAddressButton}
                            onClick={() => setNewAddress(true)}
                            data-testid="createNewShipToAddress"
                        >
                            <span className={styles.plusButton} />
                            <span>Create New Ship to Address</span>
                        </span>
                    )}
                    {newAddress && (
                        <>
                            <div
                                className={styles.newAddressForm}
                                data-testid="shippingModalNewAddressForm"
                            >
                                <FastQuoteInput
                                    value={fields.name}
                                    onChange={(value: string) =>
                                        setFields((fields: any) => ({
                                            ...fields,
                                            name: value,
                                        }))
                                    }
                                    gridColumn={5}
                                    title={'Company Name'}
                                    maxLength={35}
                                    validationText={failedToAdd && !fields.name && 'Required'}
                                    testid="shippingModalNewAddressFormCompanyName"
                                />
                                <AutocompleteAddressInput
                                    testid="shippingModalNewAddressFormStreetAddress"
                                    placeholder={''}
                                    address={fields.address1}
                                    title={'Street Address'}
                                    validationText={failedToAdd && !fields.address1 && 'Required'}
                                    span={4}
                                    setAddress={(address1: string) =>
                                        setFields((fields: any) => ({
                                            ...fields,
                                            address1,
                                        }))
                                    }
                                    setCountry={(country: string) =>
                                        setFields((fields: any) => ({
                                            ...fields,
                                            country,
                                        }))
                                    }
                                    setState={(state: string) =>
                                        setFields((fields: any) => ({
                                            ...fields,
                                            state,
                                        }))
                                    }
                                    setCity={(city: string) =>
                                        setFields((fields: any) => ({
                                            ...fields,
                                            city,
                                        }))
                                    }
                                    setZipcode={(zipcode: string) =>
                                        setFields((fields: any) => ({
                                            ...fields,
                                            zipcode,
                                        }))
                                    }
                                />
                                {/* <Input
                                    value={fields.address}
                                    onChange={(e: any) =>
                                        setFields((fields: any) => ({
                                            ...fields,
                                            address: e.target.value,
                                        }))
                                    }
                                    gridColumn={4}
                                    placeholder={'Street Address'}
                                /> */}
                                {!hasAddress2 ? (
                                    <span
                                        className={styles.streetAddressButton}
                                        onClick={() => setHasAddress2(true)}
                                        data-testid="shippingModalNewAddressFormAddStreetAddress2"
                                    >
                                        <span className={styles.plusButton} />
                                        <div>Add Street Address 2</div>
                                    </span>
                                ) : (
                                    // to have same size with both
                                    <span
                                        className={styles.streetAddressButton}
                                        onClick={() => {
                                            setHasAddress2(false)
                                            setFields((fields: any) => ({
                                                ...fields,
                                                address2: '',
                                            }))
                                        }}
                                        data-testid="shippingModalNewAddressFormRemoveStreetAddress2"
                                    >
                                        <div>Remove Street Address 2</div>
                                    </span>
                                )}
                                {hasAddress2 && (
                                    <>
                                        <FastQuoteInput
                                            value={fields.address2}
                                            onChange={(value: any) =>
                                                setFields((fields: any) => ({
                                                    ...fields,
                                                    address2: value,
                                                }))
                                            }
                                            gridColumn={4}
                                            placeholder={''}
                                            maxLength={35}
                                            title={'Street Address 2'}
                                            testid="shippingModalNewAddressFormStreetAddress2"
                                        />
                                        <span />
                                    </>
                                )}
                                <CountryDropdownList
                                    value={fields.country}
                                    onChange={(e: any) => {
                                        // clear state field if switching between us and not US
                                        if (e.target.value !== fields.country) {
                                            setFields((fields: any) => ({
                                                ...fields,
                                                state: '',
                                            }))
                                        }

                                        setFields((fields: any) => ({
                                            ...fields,
                                            country: e.target.value,
                                        }))
                                    }}
                                    validationText={failedToAdd && !fields.country && 'Required'}
                                    title={'Country'}
                                    placeholder={''}
                                    style={{ gridColumn: 'span 2', backgroundColor: 'white' }}
                                    testid="shippingModalNewAddressFormCountry"
                                />
                                <FastQuoteInput
                                    value={fields.city}
                                    maxLength={35}
                                    onChange={(value: any) =>
                                        setFields((fields: any) => ({
                                            ...fields,
                                            city: value,
                                        }))
                                    }
                                    validationText={failedToAdd && !fields.city && 'Required'}
                                    gridColumn={1}
                                    placeholder={''}
                                    title={'City'}
                                    testid="shippingModalNewAddressFormCity"
                                />
                                {fields.country === 'US' ? (
                                    <StateDropdownList
                                        value={fields.state}
                                        onChange={(e: any) =>
                                            setFields((fields: any) => ({
                                                ...fields,
                                                state: e.target.value,
                                            }))
                                        }
                                        validationText={failedToAdd && !fields.state && 'Required'}
                                        style={{ gridColumn: 'span 1', backgroundColor: 'white' }}
                                        title={'State'}
                                        testid="shippingModalNewAddressFormState"
                                    />
                                ) : (
                                    <FastQuoteInput
                                        value={fields.state}
                                        onChange={(value: any) =>
                                            setFields((fields: any) => ({
                                                ...fields,
                                                state: value,
                                            }))
                                        }
                                        gridColumn={1}
                                        maxLength={5}
                                        validationText={failedToAdd && !fields.state && 'Required'}
                                        placeholder={''}
                                        title={'State'}
                                        testid="shippingModalNewAddressFormState"
                                    />
                                )}
                                {fields.country === 'US' ? (
                                    <FastQuoteInput
                                        value={fields.zipcode}
                                        maxLength={5}
                                        onBlur={handleZipBlur}
                                        onChange={(value: string) => {
                                            setZipFieldActive(true)

                                            setFields((fields: any) => ({
                                                ...fields,
                                                zipcode: value,
                                            }))
                                        }}
                                        validationText={
                                            `${failedToAdd && !fields.zipcode ? 'Required' : ''}` +
                                            `${
                                                !zipFieldActive &&
                                                fields.zipcode &&
                                                !validUSZip(fields.zipcode)
                                                    ? ' Invalid Zip'
                                                    : ''
                                            }`
                                        }
                                        placeholder={''}
                                        title={'Zip'}
                                        gridColumn={1}
                                        testid="shippingModalNewAddressFormZip"
                                    />
                                ) : (
                                    <FastQuoteInput
                                        value={fields.zipcode}
                                        maxLength={10}
                                        onChange={(value: string) =>
                                            setFields((fields: any) => ({
                                                ...fields,
                                                zipcode: value,
                                            }))
                                        }
                                        validationText={
                                            failedToAdd && !fields.zipcode && 'Required'
                                        }
                                        placeholder={''}
                                        title={'Zip'}
                                        testid="shippingModalNewAddressFormZip"
                                    />
                                )}
                            </div>
                            <div className={styles.defaultRadio}>
                                <div
                                    style={{ height: '1em', display: 'inline-flex', gap: 5 }}
                                    className="centered"
                                >
                                    <StyledRadio
                                        onChange={(e: boolean) => {
                                            setFields((fields) => ({
                                                ...fields,
                                                isDefault: e,
                                            }))
                                        }}
                                        checked={fields.isDefault}
                                        label={'Select as Default'}
                                        data-testid="shippingModalNewAddressFormSelectAsDefault"
                                    />
                                    <span> Select as Default</span>
                                </div>
                            </div>
                        </>
                    )}
                </div>
            </Scrollbars>
            {newAddress && (
                <div className={clsx([styles.modalBody, styles.buttonContainer])}>
                    <AWCButton
                        type={'secondary'}
                        onClick={onCancelClick}
                        data-testid="shippingModalNewAddressFormCancel"
                    >
                        Cancel
                    </AWCButton>
                    <AWCButton
                        type={'primary'}
                        data-testid="shippingModalNewAddressFormSubmit"
                        style={{ width: 135 }}
                        onClick={async () => {
                            let toSave: AddShipToPayload = { ...fields }
                            // remove state if the country isn't us
                            if (toSave.country !== 'US') toSave.state = ''
                            if (validShipToPayload(toSave)) {
                                let prom = await dispatch(postAddShipTo(toSave))
                                if (prom.meta.requestStatus !== 'fulfilled') {
                                    return
                                }
                                // update shipTo or order
                                let newRow = payloadToShipToRow(toSave)
                                dispatch(updateShipTo({ shipTo: newRow }))
                                logEvent({
                                    eventName: 'Address Added From FastQuote',
                                    string2: 'Shipping Modal - Ship To',
                                    string3: toSave.accountCode,
                                    messageBody: JSON.stringify(toSave),
                                })

                                // customer card behavioir -- not jumping to quote here according to Shane

                                // await dispatch(getContacts(customer.AccountCode))
                                // let row : CustomerShipToViewRow = {
                                //     ShipToAddress1: fields.address1,
                                //     ShipToAddress2: fields.address2,
                                //     ShipToCity: fields.city,
                                //     ShipToState: fields.state,
                                //     ShipToZipcode: fields.zipcode,
                                //     ShipToCountry: fields.country,
                                //     ShipToName: fields.name,
                                //     ShipToAddress3: '',
                                //     AccountCode: customer.AccountCode,
                                //     ShipToID: -1,
                                //     TaxAuthorityCode: '',
                                //     TaxExemptCode: '',
                                //     QuoteAttachmentFormats: '',
                                //     AvailabilityMode: ''
                                // }
                                // dispatch(
                                //     startQuote({ account: customer!, shipTo: row })
                                // )
                                close()
                            } else setFailedToAdd(true)
                        }}
                    >
                        Add Address
                    </AWCButton>
                </div>
            )}
        </div>
    )
}

export default ShippingModal
